<i18n src="@/i18n/components/AdvancedFilter.json"></i18n>
<template>
	<div v-show="show" ref="drop"
		 class="absolute left-0 right-0 z-10 mt-3 min-w-[16rem] w-fit origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
		 role="menu" aria-orientation="vertical"
		 aria-labelledby="menu-button" tabindex="-1">
		<div class="py-1" role="none" @click.stop="() => {}">
			<template v-if="!filter.field">
				<!-- Field !-->
				<template v-for="(field, index) in fields">
					<button class="flex w-full text-left text-gray-700 px-4 py-2 text-sm hover:bg-turquoise hover:text-white hover:font-semibold" role="menuitem" tabindex="-1"
							@click="handleSelectField(field, index)">{{ field.label }} <i class="ml-auto" :class="fieldIcon(field)"></i>
					</button>
				</template>
			</template>
			<template v-else>
				<div class="flex flex-col space-y-2 px-4 py-2 text-sm">
					<!-- Operator !-->
					<FormSelect ref="fieldOperator" v-if="avaibleOperationOptions.length" :value="filter.operator" :options="avaibleOperationOptions" @input="handleSelectOperator" />
					<!-- Value !-->
					<div class="flex space-x-2 items-center">
						<i class="fa fa-arrow-turn-down-right text-gray-400"></i>
						<!-- Search Fields !-->
						<template v-if="filter.field.type === 'text'">
							<!-- Text !-->
							<FormInput ref="fieldValue" :value="filter.value" @input="handleUpdateValue" @enter="handleApplyFilter" />
						</template>
						<template v-else-if="filter.field.type === 'select'">
							<!-- Select !-->
							<FormSelect ref="fieldValue" :options="filter.field.options" :value="filter.field.value" @change:object="handleUpdateSelectValue" class="w-full max-w-md" />
						</template>
						<template v-if="filter.field.type === 'date' || filter.field.type === 'datetime'">
							<!-- Date !-->
							<FormDatePicker ref="fieldValue" @input="handleUpdateValue" @enter="handleApplyFilter" />
						</template>
						<template v-else-if="filter.field.type === 'partner'">
							<div class="min-w-[300px]">
								<SelectPartner ref="fieldValue" :selected="filter.value" @update:selected="handleUpdateValue" class="max-w-md" />
							</div>
						</template>
						<template v-else-if="filter.field.type === 'provider|freight_forwarder'">
							<SelectProvider ref="fieldValue" :selected="filter.value" only-freight-forwarder @update:selected="handleUpdateValue" class="max-w-md" />
						</template>
						<template v-else-if="filter.field.type === 'provider|fulfillment'">
							<SelectProvider ref="fieldValue" :selected="filter.value" only-fulfillment @update:selected="handleUpdateValue" class="max-w-md" />
						</template>
						<template v-else-if="filter.field.type === 'provider|firstmile'">
							<SelectProvider ref="fieldValue" :selected="filter.value" only-first-mile @update:selected="handleUpdateValue" class="max-w-md" />
						</template>
						<template v-else-if="filter.field.type === 'provider|lastmile'">
							<SelectProvider ref="fieldValue" :selected="filter.value" only-last-mile @update:selected="handleUpdateValue" class="max-w-md" />
						</template>
						<template v-else-if="filter.field.type === 'manifest'">
							<SelectProvider ref="fieldValue" :selected="filter.value" only-last-mile @update:selected="handleUpdateValue" class="max-w-md" />
						</template>
						<template v-else-if="filter.field.type === 'tracking_event'">
							<SelectTrackingEvent ref="fieldValue" :selected="filter.value" @update:selected="handleUpdateTranslateValue" class="max-w-md" />
						</template>
						<template v-else-if="filter.field.type === 'department'">
							<div class="min-w-[300px]">
								<SelectDepartment ref="fieldValue" :selected="filter.value" @update:selected="handleUpdateValue" class="max-w-md" />
							</div>
						</template>
						<template v-else-if="filter.field.type === 'user'">
							<div class="min-w-[300px]">
								<SelectUser ref="fieldValue" :selected="filter.value" @update:selected="handleUpdateValue" class="max-w-md" />
							</div>
						</template>
						<template v-else-if="filter.field.type === 'support_subject'">
							<div class="min-w-[300px]">
								<SupportSubjectSelect ref="fieldValue" :value="filter.value && filter.value.id" @input:object="handleUpdateSelectValue" class="max-w-md" />
							</div>
						</template>
						<!--						<template v-else-if="filter.field.type === 'shipment|modal'">-->
						<!--							<SelectShipmentModal ref="fieldValue" :selected="filter.value" only-last-mile @update:selected="handleUpdateValue" class="max-w-md" />-->
						<!--						</template>-->
						<!--						<template v-else-if="filter.field.type === 'shipment|type'">-->
						<!--							<SelectShipmentType ref="fieldValue" :selected="filter.value" only-last-mile @update:selected="handleUpdateValue" class="max-w-md" />-->
						<!--						</template>-->
					</div>
					<button type="button" class="block w-full px-4 py-2 text-sm bg-blue-500 text-white text-center rounded" role="menuitem" tabindex="-1"
							@click.stop="handleApplyFilter">{{ $t("advanced_filter.buttons.apply") }}
					</button>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import FormSelect from "@/components/FormSelect.vue"
import FormInput from "@/components/FormInput.vue"
import FormDatePicker from "@/components/FormDatePicker.vue"
import SelectPartner from "@/domain/partners/SelectPartner.vue"
import SelectProvider from "@/domain/providers/SelectProvider.vue"
import SelectTrackingEvent from "@/domain/tracking_events/SelectTrackingEvent2.vue"
import SelectDepartment from "@/domain/departments/SelectDepartment.vue"
import SelectUser from "@/domain/users/SelectUser.vue"
import SupportSubjectSelect from "@/domain/support_subjects/SupportSubjectSelect.vue"

export default {
	name: "AdvancedFilterOperation",
	components: {
		SelectTrackingEvent,
		SelectDepartment,
		SelectUser,
		SupportSubjectSelect,
		SelectProvider,
		SelectPartner,
		FormDatePicker,
		FormInput,
		FormSelect
	},
	model: {
		prop: "filter",
		event: "update:filter"
	},
	props: {
		show: {
			type: Boolean,
			required: true
		},
		filter: {
			type: Object,
			required: true
		},
		fields: {
			type: Array,
			required: true
		}
	},
	emits: ["update:filter"],
	computed: {
		avaibleOperationOptions() {
			if (!this.filter?.field?.operators) return []
			return this.filter.field.operators.map(item => {
				return {
					label: this.$t("advanced_filter.filters." + item),
					id: item
				}
			})
		}
	},
	methods: {
		/**
		 * Handle select field
		 * @param field
		 * @param index
		 */
		handleSelectField(field, index) {

			let operator = null

			if (field?.operators?.indexOf("eq") > -1) {
				operator = "eq"
			}

			this.$emit("update:filter", {
				field,
				operator,
				value: null
			})

			if (operator) {
				this.$nextTick(() => this.$refs.fieldValue?.focus?.())
			}
		},
		/**
		 * Handle select operator
		 * @param evt
		 */
		handleSelectOperator(evt) {
			this.$emit("update:filter", {
				field: this.filter.field,
				operator: evt,
				value: this.filter.value
			})
			// this.$refs.fieldValue.focus()
		},
		/**
		 * Handle update value
		 * @param evt
		 */
		handleUpdateValue(evt) {
			this.$emit("update:filter", {
				field: this.filter.field,
				operator: this.filter.operator,
				value: evt
			})
		},
		/**
		 * Handle update value
		 * @param evt
		 */
		handleUpdateTranslateValue(evt) {
			this.$emit("update:filter", {
				field: this.filter.field,
				operator: this.filter.operator,
				value: evt
			})
		},
		/**
		 * Handle update value
		 * @param evt
		 */
		handleUpdateSelectValue(evt) {
			this.$emit("update:filter", {
				field: this.filter.field,
				operator: "eq",
				value: evt
			})
		},
		/**
		 * Handle apply filter
		 */
		handleApplyFilter() {
			this.$emit("update:show", false)
			this.$emit("apply", this.filter)
		},
		fieldIcon(field) {

			if (field.icon) return field.icon

			if (field.type === "text") {
				return "fal fa-text"
			}

			if (field.type === "manifest") {
				return "fal fa-bookmark"
			}

			if (field.type === "shipment_item_type") {
				return "fal fa-box"
			}

			if (field.type === "date") {
				return "fal fa-calendar-alt"
			}

			if (field.type === "department") {
				return "fal fa-sitemap"
			}

			if (field.type === "user") {
				return "fal fa-user"
			}

			if (field.type === "support_subject") {
				return "fal fa-comment-alt-lines"
			}

			if (field.type.search("provider") > -1) {
				return "fal fa-building"
			}

			if (field.type.search("partner") > -1) {
				return "fal fa-building"
			}

			if (field.type.search("country") > -1) {
				return "fal fa-earth-americas"
			}
		}
	},
	watch: {
		show: {
			immediate: true,
			handler(v) {

				if (v) {
					const clickAway = (evt) => {
						const closest = evt.target.closest(".drop")
						if (!closest && closest !== this.$refs.drop) this.$emit("update:show", false)
					}

					const handlePressEsc = (evt) => {
						if (evt.keyCode === 27) this.$emit("update:show", false)
					}

					setTimeout(() => {
						document.addEventListener("click", clickAway, false)
						document.addEventListener("keydown", handlePressEsc, false)
						this.$once("hook:beforeDestroy", () => {
							document.removeEventListener("click", clickAway, false)
							document.removeEventListener("keydown", handlePressEsc, false)
						})
					}, 100)
				}
			}
		}
	}
}
</script>